/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitation_AcceptInputs */

const th_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอบรับ`)
};

const en_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

const ja_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認する`)
};

const zh_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受`)
};

const es_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar`)
};

const pt_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar`)
};

const id_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima`)
};

const fr_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

const tl_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggapin`)
};

const vi_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận`)
};

const ko_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수락`)
};

const de_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annehmen`)
};

const ru_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принять`)
};

const tr_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabul et`)
};

const it_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta`)
};

const pl_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przyjmij`)
};

const uk_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прийняти`)
};

const hi_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकार करें`)
};

const ar_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول`)
};

const ms_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terima`)
};

const bn_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গ্রহণ`)
};

const zh_tw2_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受`)
};

const zh_hk2_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受`)
};

const ur_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول کریں`)
};

const fa_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پذیرفتن`)
};

const sw_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kubali`)
};

const nl_invitation_accept = /** @type {(inputs: Invitation_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aannemen`)
};

/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Invitation_AcceptInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invitation_accept = /** @type {((inputs?: Invitation_AcceptInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitation_AcceptInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invitation_accept(inputs)
	if (locale === "ja") return ja_invitation_accept(inputs)
	if (locale === "zh") return zh_invitation_accept(inputs)
	if (locale === "es") return es_invitation_accept(inputs)
	if (locale === "pt") return pt_invitation_accept(inputs)
	if (locale === "id") return id_invitation_accept(inputs)
	if (locale === "fr") return fr_invitation_accept(inputs)
	if (locale === "tl") return tl_invitation_accept(inputs)
	if (locale === "vi") return vi_invitation_accept(inputs)
	if (locale === "ko") return ko_invitation_accept(inputs)
	if (locale === "de") return de_invitation_accept(inputs)
	if (locale === "ru") return ru_invitation_accept(inputs)
	if (locale === "tr") return tr_invitation_accept(inputs)
	if (locale === "it") return it_invitation_accept(inputs)
	if (locale === "pl") return pl_invitation_accept(inputs)
	if (locale === "uk") return uk_invitation_accept(inputs)
	if (locale === "hi") return hi_invitation_accept(inputs)
	if (locale === "ar") return ar_invitation_accept(inputs)
	if (locale === "ms") return ms_invitation_accept(inputs)
	if (locale === "bn") return bn_invitation_accept(inputs)
	if (locale === "zh-TW") return zh_tw2_invitation_accept(inputs)
	if (locale === "zh-HK") return zh_hk2_invitation_accept(inputs)
	if (locale === "ur") return ur_invitation_accept(inputs)
	if (locale === "fa") return fa_invitation_accept(inputs)
	if (locale === "sw") return sw_invitation_accept(inputs)
	if (locale === "nl") return nl_invitation_accept(inputs)
	return en_invitation_accept(inputs)
});